<template>
    <div id="applicant-address-confirmation">
        <div class="vx-row mb-base">
            <div  class="vx-col w-full mb-4">
                <h2>Comprobante domicilio de tu obligado solidario</h2>
                <p>Ingresa el comprobante de domicilio no mayor a 3 meses, legible, sin cortes.</p>
                <vs-divider></vs-divider>
            </div>
            <div v-if="!isEdit" class="vx-col w-full mb-4">
                <h4 class="mb-4">Tu comprobante de domicilio debe coincidir con esta dirección:</h4>
                <div class="address-card sm:w-full md:w-1/3">
                    <div class="flex">
                        <feather-icon 
                            icon="MapPinIcon"
                            svgClasses="w-5 h-5 m-1 mr-2 mt-0"
                            class="cursor-pointer text-accent" />
                        <p class="bold mb-1">Dirección de domicilio</p>
                    </div>
                    <div class="flex justify-between">
                        <p class="ml-8 mr-2">{{ hasFullAddress ? address.full_address : 'Agrega tu dirección'  }}</p>
                        <vs-button size="small" type="line" @click.stop="isEdit = true">{{ hasFullAddress ? 'Editar' : 'Agregar' }}</vs-button>
                    </div>
                </div>
            </div>
            <div v-else class="vx-col w-full mb-4">
                <vx-card>
                    <GuaranteeAddressData
                        :project="onboardingStepData"
                        @updated="getProjectData"
                        :isEdit="true"></GuaranteeAddressData>
                </vx-card>
            </div>

            <vs-divider class="mt-12 mb-base ml-3 mr-3"></vs-divider>
            <div class="vx-col sm:w-full md:w-10/12 mb-4 m-1">
                <h4 class="mb-4">Selección del documento</h4>
                <p class="bold black text-lg mb-4">Puede ser de cualquiera de estos servicios</p>
                <div class="vx-row">
                    <div class="vx-col sm:w-full md:w-1/2">
                        <div class="vx-row flex-end mb-base">
                            <div class="vx-col sm:w-1/2 md:w-1/12 center">
                                <img :src="icons['BulbIcon']" svgClasses="w-10 h-10 m-1 mr-2 mt-0 mb-4" class="cursor-pointer text-accent align-self-felx-start" />
                                <p class="mt-2">Luz</p>
                            </div>
                            <div class="vx-col sm:w-1/2 md:w-1/12 center phone">
                                <img :src="icons['PhoneIcon']" svgClasses="w-10 h-10 m-1 mr-2 mt-0 mb-4" class="cursor-pointer text-accent align-self-felx-start" />
                                <p class="mt-2">Teléfono</p>
                            </div>
                            <div class="vx-col sm:w-1/2 md:w-1/12 center">
                                <img :src="icons['DropIcon']" svgClasses="w-10 h-10 m-1 mr-2 mt-0 mb-4" class="cursor-pointer text-accent align-self-felx-start" />
                                <p class="mt-2">Agua</p>
                            </div>
                            <div class="vx-col sm:w-1/2 md:w-1/12 center">
                                <img :src="icons['MonitorIcon']" svgClasses="w-10 h-10 m-1 mr-2 mt-0 mb-4" class="cursor-pointer text-accent align-self-felx-start" />
                                <p class="mt-2">Cable</p>
                            </div>
                            <div class="vx-col sm:w-1/2 md:w-1/12 center">
                                <img :src="icons['FlameIcon']" svgClasses="w-10 h-10 m-1 mr-2 mt-0 mb-4" class="cursor-pointer text-accent align-self-felx-start" />
                                <p class="mt-2">Gas</p>
                            </div>
                        </div>
                        <div class="document-detail">
                            <p class="bold black text-lg mb-4">Antes de subir el documento verifica que el comprobante:</p>
                            <ul class="check-ul">
                                <li class="black">Tenga <span class="bold">máximo 3 meses</span> de antigüedad.</li>
                                <li class="black">Muestre la <span class="bold">calle, colonia y código postal</span>. Debe ser legible.</li>
                                <li class="black">Esté completo, sin cortes.</li>
                                <li class="black">Cumpla con formato PDF, JPG, GIF o PNG.</li>
                                <li class="black">El archivo pese máximo 10 MB.</li>
                            </ul>
                        </div>
                    </div>
                    <div class="vx-col sm:w-full md:w-1/2">
                        <document-upload
                            v-if="isMounted"
                            v-for="df in allDocumentFields"
                            :key="df.id"
                            :target_id="df.target_id"
                            :f="df.formField"
                            :doc="df.documentSet"
                            :inputClassExtraLarge="true"
                            :disabled="isVerified"
                            :evaluator="evaluateCondition"
                            :loadedState="df.loadedState"
                            :stickToLoadedState="true"
                            :from_project_id="currentProjectId"
                            :editableByBackoffice="true"
                            @on-success="onDocumentUploadSuccess"
                        />
                        <!-- <div class="centerx">
                            <vx-upload
                                class="upload-container"
                                text="Seleccione o arrastre un archivo"
                                ref="vsupload"
                                :automatic="true"
                                :action="uploadAction"
                                :data="dataForm"
                                :alreadyLoaded="hasAlreadyDocument"
                                :fileIsVerified="isVerified"
                                :fileIsRejected="isRejected"
                                :loadedFileName="documentName"
                                fileName="file"
                                :acceptFileTypes="['pdf','jpeg','jpg','png']"
                                :headers="headers"
                                @on-success="successUpload"
                                @on-invalid-extension="onInvalidExtensionEvent"
                            />
                            <div v-if="showAlerts" class="flex justify-between flex-wrap mb-4 small-flex">
                                <vs-alert v-if="onError && !fileWasLoaded" color="danger" style="height: auto">{{ invalidExtension ? invalidExtensionError : genericError }} {{ apiErrors != '' ? apiErrors : '' }}</vs-alert>
                                <vs-alert v-if="onError && fileWasLoaded" color="danger" style="height: auto">{{ invalidExtension ? invalidExtensionError : genericError }} {{ apiErrors != '' ? apiErrors : '' }} {{ remainMssg }}</vs-alert>
                                <vs-alert v-if="onSuccess" color="success" style="height: auto">
                                El archivo ha sido cargado correctamente{{(docSets.verification_required) ? " y será validado por el equipo de RedGirasol." : "."}}
                                </vs-alert>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col sm:w-1/2 md:w-1/12">
                <vs-button size="sm" color="black" type="border" @click.stop="goBack()">Atrás</vs-button>
            </div>
            <div class="vx-col sm:w-1/2 md:w-2/12">
                <!-- <vs-button class="w-full" size="sm" color="black">Continuar</vs-button> -->
            </div>
        </div>
    </div>
</template>

<script>
import VxUpload from '@upload/VxUpload';
import GuaranteeAddressData from './GuaranteeAddressData.vue';
import docsHelper from '@components/mixins/docsHelper';
import formHelper from '@components/mixins/formHelper';

const PF_ADDRESS_PROOF_DOCUMENT = "applicant_pf_os_address";
const PF_ADDRESS_PROOF_ID = 44;

const verifiedEnumValue = "verificado";
const rejectedEnumValue = "rechazado";

export default {
    name: "GuaranteeAddressDocument",
    props: ["onboardingStepData", "isMoral", "isRepLegal","document"],
    mixins: [docsHelper, formHelper],
    components: {
        VxUpload,
        GuaranteeAddressData
    },
    data: () => ({
        isEdit: false,
        icons: {
            'BulbIcon' : require("@assets/images/loan-onboarding/bulb-icon.svg"),
            'PhoneIcon' : require("@assets/images/loan-onboarding/phone-icon.svg"),
            'DropIcon' : require("@assets/images/loan-onboarding/drop-icon.svg"),
            'MonitorIcon' : require("@assets/images/loan-onboarding/monitor-icon.svg"),
            'FlameIcon' : require("@assets/images/loan-onboarding/flame-icon.svg")
        },
        onError: false,
        onSuccess: false,
        hasFile: false,
        /* mensajes */
        genericError: "Ha ocurrido un error con la carga.",
        invalidExtensionError: "El tipo de archivo seleccionado no es válido, intente con otro archivo.",
        updateError: "Ha ocurrido un error al intentar actualizar",
        remainMssg: "El archivo cargado previamente seguirá activo.",
        apiErrors: "",
        // document: null,
        pmSections: [124],
        pfSections: [20],
        flow_id_pf: 4,
        flow_id_pm: 5,
        validatedDocuments: [],
        allDocumentFields: [],
        documentsStates: [],
        allSections: [],
        isMounted: false,
    }),
    async mounted() {
        // this.getDocument();
        await this.getSections();
    },
    computed: {
        base() {
            if(this.isRepLegal) {
                return this.onboardingStepData.client;
            } else {
                return this.onboardingStepData;
            } 
        },
        guarantee() {
            return this.base.finance.guarantee.guarantee_profile;
        },
        address() {
            return this.base.finance.guarantee.guarantee_profile.personal.address;
        },
        hasFullAddress() {
            return this.address.neighborhood_id != null;
        },
        // apiStorageBasePrefix(){
        //     return this.ApiDomain + "/storagev3/documents/";
        // },
        currentAccessToken(){
            return this.AccessToken;
        },
        // uploadAction() {
        //     let url = this.apiStorageBasePrefix;
        //     if(this.hasAlreadyDocument) {
        //         return `${url}upload/user/${this.UserId}/update/${this.document.id}`;
        //     } else {
        //         return `${url}upload/user/${this.UserId}`;
        //     }
        // },
        headers(){
            // "Access-Control-Allow-Origin": process.env.VUE_APP_API_DOMAIN,
            //     "Access-Control-Allow-Credentials": process.env.VUE_APP_CORS_ALLOW_CREDENTIALS,
            return {
                "Access-Control-Allow-Origin": false,
                "Access-Control-Allow-Credentials": false,
                "X-Requested-With": "XMLHttpRequest",
                "Authorization": "Bearer " + this.currentAccessToken,
            };
        },
        showAlerts(){
            return (this.onSuccess || this.onError);
        },
        hasAlreadyDocument() {
            return this.document != null && this.document.id != null;
        },
        isVerified(){
            return (this.document?.is_verified == "verificado");
        },
        isRejected(){
            return (this.document?.is_verified == "rechazado");
        },
        documentName() {
            return this.document?.storage_file;
        },
        stakeholderIsMoral() {
            return this.base.stakeholder_bp_id != null;
        },
        address_document_id() {
            return PF_ADDRESS_PROOF_ID;
        },
        address_document_prefix() {
            return PF_ADDRESS_PROOF_DOCUMENT;
        },
        dataForm() {
            return {
                file_type: this.address_document_prefix,
                assocData: this.guarantee.id
            };
        },
        currentProjectId() {
            return this.base.id;
        },
    },
    methods: {
        async getProjectData() {
            this.isEdit = false;
            await this.$emit('updated', 1);
        },
        async goBack() {
            await this.$emit('on-back', 1);
        },
        async upload() {
            let doc = document.getElementById(";");
            const formData = new FormData();
            const data = this.dataForm;
            this.injectAccountMetadataToFormData(obj);
            for (var key in data) {
                formData.append(key, data[key]);
            }

            if(doc.files.length > 0){
                data.append("applicants_layout", doc.files[0]);
                const res = await axios.post(`${this.uploadAction()}`, data);
            }
        },
        // async getDocument() {
        //     try {
        //         const response = await axios.get(`${this.apiStorageBasePrefix}get/document-data/${this.address_document_id}/${this.UserId}`);
        //         this.document = response.data;
        //     } catch (error) {
        //         this.showLoading(false);
        //         this.$vs.notify({
        //             title: 'Error',
        //             text: 'Ocurrió un error al obtener la información',
        //             color: 'danger',
        //             position: 'top-right'
        //         });
        //     }
        // },
        successUpload() {
            this.$vs.notify({
                title: '¡Documento guardado!',
                text: 'Tu comprobante de domicilio ha sido guardado con éxito.',
                color: 'success',
                position: 'top-right'
            });
        
        },
        onInvalidExtensionEvent(){
            this.onError = true;
            this.invalidExtension = true;
        },
        async getSections() {
            try {
                this.showLoading(true);
                const sections = this.isMoral ? this.pmSections : this.pfSections;
                const res = await axios.post("/api/v1/forms/getSectionsByArrayIds", { section_ids: sections });
                let id = this.isMoral == true ? this.flow_id_pm : this.flow_id_pf;
                let url = this.ApiDomain + `/storagev3/documents/flow/${id}`;
                let response2 = await axios.get(url);
                this.documentsStates = response2.data;
                this.allSections = res.data.sections;
                this.allDocumentFields = [];

                this.allSections.forEach(s => {
                    // s.containers = this.getContainersForSection(s.id);
                    s.documentFields = [];

                    s.fields.forEach(f => {
                        this.formFieldSetter(f, this);
                        if(f.doc_id != null){
                            if(s.id == 27) {
                                if(f.doc_id == 31 || f.doc_id == 26) 
                                return;
                        }

                        let ff = {formField: f, documentSet: null, target_id: null };
                        let ss = this.documentsStates.find(sid => sid.id == s.id);
                        if(ss && ss.documents){
                            let dset = ss.documents.find(d => d.id == f.doc_id);
                            if(dset){
                                ff.target_id = this.docTargetEvaluator(dset.clasification, dset.clasification_2);
                                ff.documentSet = dset;
                            }
                        }
                            s.documentFields.push(ff);
                            this.allDocumentFields.push(ff);
                        }
                    })
                });

                let docRes = await this.getAllDocumentsStates(this.allDocumentFields, this.evaluateCondition);
                if(docRes){
                    this.allDocumentFields.forEach(f => {
                        if(f.loadedState && f.loadedState.is_verified == verifiedEnumValue){
                            this.validatedDocuments.push(f.documentSet.id);
                        }
                    })
                }
                this.isMounted = true;
                this.showLoading(false);
            } catch (error) {
                this.showLoading(false);
                console.log(error);
            }
            this.showLoading(false);
        },
        evaluateCondition(condition){
            return this.evaluateConditionBase(this, condition);
        },
        /* obtener ids para los casos correspondientes */
        docTargetEvaluator(cls, cls_2){
            if(cls == 'user'){
                if(cls_2 == 'applicant'){
                    return this.base.client.user.id;
                }
            }
            else if(cls == 'project'){
                return this.base.id;
            }
            this.warn(`DOC TARGET NOT DEFINED FOR classifications: ${cls},${cls_2}`);
            return null;
        },
        onDocumentUploadSuccess(data){
            let d = this.allDocumentFields.find(f => f.documentSet.id == data.document_id);
            d.loadedState = data;
        },
    }
}
</script>

<style>

.address-card {
    border-radius: 8px;
    border: 1px solid #28DE18;
    padding: 1rem;
    width: fit-content;
}

.vs-button.small:not(.includeIconOnly) {
    padding: 1px
}

.address-card {
    padding: 2rem;
    width: fit-content;

}

.center {
    text-align: -webkit-center;
    margin-right: 10px;

}

.center.phone p {
    margin-left: -1rem;
}

.flex-end {
    place-items: flex-end;
}

ul.check-ul {
    list-style: none;
    line-height: 25px;
}

    ul.check-ul li:before {
        content: '✓';
        color: #28DE18;
        margin-right: 12px;
    }
.con-input-upload {
    background-color: #f7fff6;
    width: inherit;
    margin-left: 0;
    /* width: 35rem !important; */
    font-size: 1.3rem !important;
}
</style>